module.exports = __webpack_public_path__ + "img/chip_100k.b20cfb81.png";